import React, { JSX } from 'react';
import EventStatusTransitionDialogFrame from './EventStatusTransitionDialogFrame';

type Props = {
  open: boolean;
  eventId: string;
  eventName?: string;
  subtitleOverride?: string;
  busy: boolean;
  onCancel: () => void;
  onProceed: () => void | Promise<void>;
};

export default function DraftToDevicePackagingConfirmDialog(props: Props): JSX.Element | null {
  const { open, eventId, eventName, subtitleOverride, busy, onCancel, onProceed } = props;
  const subtitle = subtitleOverride?.trim() || (eventName?.trim() ? eventName : eventId);

  return (
    <EventStatusTransitionDialogFrame
      open={open}
      busy={busy}
      onCancel={onCancel}
      onProceed={onProceed}
      titleId="draft-to-device-packaging-title"
      eyebrow="Race planning"
      title="Move to Device Packaging"
      subtitle={subtitle}
      headerAccent="amber"
      warningTone="info"
      warningTitle="Before you proceed"
      warningBody={
        <>
          Device Packaging is where you assign rear and front devices to athletes from the athlete list uploaded
          in Draft. You can move this race <strong>back to Draft</strong> later; device assignments and other race
          data are kept.
        </>
      }
      confirmPhrase="PACKAGING"
      confirmInputId="draft-to-device-packaging-confirm-input"
      proceedButtonText="Proceed to Device Packaging"
      proceedUseSuccessTone={false}
    />
  );
}
